<template>
  <div>
    <cgil-ol-map style="height: 800px; width: 100%"
                 :edit-geom-enabled="true"
                 :center="center"
                 :zoom="8"
                 :layers-config="mapLayers"
                 :geomWkt="initialGeom"
                 @gomapSaveGeomClick="saveGeometry"
    ></cgil-ol-map>
    <el-input
      title="initial geometry"
      type="textarea"
      :rows="4"
      placeholder="Initial geometry"
      v-model="initialGeom">
    </el-input>
    <el-input
      title="saved geometry"
      type="textarea"
      :rows="4"
      placeholder="saved geometry"
      v-model="savedGeom">
    </el-input>
    <!--
    <go-collapse title="Test composant goSelectCountry " :open="isTestCountryOpen">
        <go-select-country v-model="country"></go-select-country>
        <p v-if="country">Outside goSelect Country choosen is :{{country}}</p>
        <button>Set default to suisse</button>
        <vue-awesomplete :ajax="ajax_country" class="dropdown-input" ></vue-awesomplete>
    </go-collapse>
    <go-collapse title="Test composant GoSelectCanton (Suisse uniquement)" :open="isTestCantonOpen">
      <go-select-canton v-model="canton"></go-select-canton>
      <p v-if="canton">Outside goSelect Canton choosen is :{{canton}}</p>
      <button>Set default to vaud</button>
    </go-collapse>
    <go-collapse :title="getTestCommuneMSg" :open="isTestCommuneOpen">
      <go-select-commune v-model="commune" :idCanton="canton"></go-select-commune>
      <p v-if="canton">Outside goSelect Commune choosen is :{{commune}}</p>
      <button>Set default to Lausanne</button>
    </go-collapse>
    <go-collapse title="Test composant GoSelectActeur" :open="isTestActeurOpen">
      <go-select-acteur v-model="acteur" v-on:saverequest="saveActeur"></go-select-acteur>
      <p v-if="acteur">Outside goSelect Acteur choosen is :{{acteur}}</p>
    </go-collapse>
    <go-collapse title="Test composant goSelectPodpDemande" :open="isTestPopdOpen">
      <go-select-podp-demande v-model="popdDemande" ></go-select-podp-demande>
      <p v-if="popdDemande">Outside goSelect Popd choosen is :{{popdDemande}}</p>
    </go-collapse>

    <datepicker v-model="datebegin"
                language="fr" :full-month-name="true" :bootstrapStyling="true"></datepicker>
    <p>{{datebegin}}</p>
    -->
  </div>
</template>

<script>
/*
  import goCollapse from './ui/goCollapse'
  import goSelectCountry from './geo/goSelectCountry.vue'
  import goSelectCanton from './geo/goSelectCanton.vue'
  import goSelectCommune from './geo/goSelectCommune.vue'
  import goSelectActeur from './geo/goSelectActeur.vue'
  import goSelectPodpDemande from './goSelectPodpDemande.vue'
  import Datepicker from 'vuejs-datepicker'
 */
  import {getLog} from './config'
  import cgilOlMap from './cgil-vue-olmap/cgil-vue-olmap'
  import './cgil-vue-olmap/ol.css'
  import {getStringParam} from 'cgil-html-utils'
  import {hexToArr} from './cgil-vue-olmap/tools'

  const log = getLog('goelandTest', 4, 1)
  const baseLayerSelected = getStringParam('baselayer', 'fonds_geo_osm_bdcad_gris')
  const layersVisibility = getStringParam('lvisibles', '41')
  const arrLayersVisibility = hexToArr(`0x${layersVisibility}`)
  log.w(`layersVisibility:${layersVisibility} => arrLayersVisibility: ${arrLayersVisibility}`)

  const defaultCountry = {'value': 197, 'label': 'Suisse'}
  const defaultCanton = { 'value': 22, 'label': 'Vaud' }
  const defaultCommuneVD = { 'value': 5586, 'label': 'Lausanne' }
  const pos = [538350.5, 152669.0] // cathedrale Lausanne

  export default {
    name: 'home',
    components: {
      /*
      goCollapse,
      goSelectCountry,
      goSelectCanton,
      goSelectCommune,
      goSelectActeur,
      goSelectPodpDemande,
      Datepicker,
       */
      cgilOlMap
    },
    data: function () {
      return {
        center: pos,
        initialGeom:
          `MULTIPOLYGON(((2538319.52 1152664.64,2538318.72 1152659.83,2538343.55 1152656.63,2538344.15 1152661.63,2538319.52 1152664.64)),((2538352.76 1152659.83,2538351.16 1152645.21,2538361.57 1152644.41,2538362.78 1152651.02,2538372.19 1152650.02,2538374.19 1152657.03,2538352.76 1152659.83)))`,
        savedGeom: null,
        isTestCountryOpen: false,
        country: defaultCountry,
        isTestCantonOpen: false,
        canton: defaultCanton,
        isTestCommuneOpen: false,
        commune: defaultCommuneVD,
        isTestActeurOpen: false,
        acteur: null,
        isTestPopdOpen: true,
        popdDemande: null,
        datebegin: null,
        ajax_country: {
          callback: function (response) {
            return response.map(function (i) {
              return i.name
            })
          },
          url: 'https://restcountries.eu/rest/v1/lang/fr'
        },
        mapLayers: {
          baseLayer: baseLayerSelected,
          layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
          wmsLayers: [
            {
              layers: 'bdcad_projets_msgroup',
              title: 'Projets et chantiers',
              isVisible: arrLayersVisibility[0]
            },
            {
              layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
              title: 'PFP',
              isVisible: arrLayersVisibility[1]
            },
            {
              layers: 'bdcad_pfp_reperage_msgroup',
              title: 'PFP repérage',
              isVisible: arrLayersVisibility[2]
            },
            {
              layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
              title: 'PFA',
              isVisible: arrLayersVisibility[3]
            },
            { // je choisis la version du GC public pour que cela fonctionne partout
              layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
              title: 'Arbres',
              isVisible: arrLayersVisibility[4]
            },
            {
              layers: 'envconst_toitures_veg',
              title: 'Toitures Végétalisées',
              isVisible: arrLayersVisibility[5]
            },
          /* // pas disponible sur map :
          {
            layers: 'bdcad_bf_parcom_pol',
            title: 'Parcelles Communales',
            isVisible: arrLayersVisibility[6],
          },
             */
            {
              layers: 'perimetres_lim_com_msgroup',
              title: 'Limites Communales',
              isVisible: arrLayersVisibility[6]
            },
            {
              layers: 'altimetrie_hauteur_vegetation_mnc_class',
              title: 'Canopée végétation',
              isVisible: arrLayersVisibility[7]
            }
          ]
        } // FIN DE LA CONFIG DES mapLayers
      }
    },
    computed: {
      getTestCommuneMSg: function () {
        if (this.canton !== null) {
          return `Test composant goSelectCommune (Suisse) ${this.canton.label}`
        } else {
          return `Test composant goSelectCommune (Suisse) `
        }
      }
    },
    methods: {
      saveActeur: function (val) {
        log.l(`## IN Test.vue.saveActeur\n received :`, val)
      },
      saveGeometry: function (val) {
        console.info('In demoApp cgil-vue-olmap event gomapSaveGeomClick received : ', val)
        this.savedGeom = val
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Test.vue